var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _path71, _path72, _path73, _g15, _g16, _path74, _path75, _path76, _g17, _g18, _path77, _path78, _path79, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDf5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 114,
    viewBox: "0 0 141 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.9748 10.4614C81.89 4.2906 76.8052 16.6322 71.7204 10.4614C71.7204 8.40377 71.7204 3.83776 71.7204 1.78013C76.8052 7.95092 81.89 -4.39066 86.9748 1.78013V10.4614Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1368 18.9528C70.6767 18.9528 70.3022 18.5813 70.3022 18.1202V2.45423C70.3022 1.99513 70.6746 1.62158 71.1368 1.62158C71.597 1.62158 71.9714 1.99304 71.9714 2.45423V18.1202C71.9714 18.5793 71.5991 18.9528 71.1368 18.9528Z",
    fill: "#A6733A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.927 58.3418H83.377L93.0006 45.6538H132.985L140.927 58.3418Z",
    fill: "#A6733A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.445 58.3418H0L7.69099 45.6538H47.7941L57.445 58.3418Z",
    fill: "#A6733A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.18 58.3837V114H1.67334V58.3837H44.9558V37.3838H95.8999V58.3837H139.18Z",
    fill: "#FEDF9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0103 37.2606H43.8428L44.6376 35.4784C49.4337 24.7061 59.4486 17.8655 70.4255 17.8655C70.6347 17.8655 70.8418 17.8676 71.0467 17.8738C76.3093 17.9969 81.3314 19.6915 85.636 22.6318C90.1121 25.689 93.8143 30.0902 96.2155 35.4784L97.0083 37.2606H97.0103Z",
    fill: "#FDC860"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8823 83.8035H94.9754V89.2397C94.9754 89.9743 94.3772 90.5711 93.6409 90.5711H47.2189C46.4826 90.5711 45.8844 89.9743 45.8844 89.2397V83.8035H45.8823Z",
    fill: "#FFF1D7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6661 90.571C93.6661 90.9675 93.5594 91.3411 93.3712 91.6604C93.2792 91.8252 93.1599 91.9797 93.0261 92.1132C92.6287 92.5097 92.0827 92.7539 91.4783 92.7539H49.3734C48.5639 92.7539 47.8591 92.3136 47.4805 91.6625C47.2922 91.3432 47.1855 90.9696 47.1855 90.5731H93.664L93.6661 90.571Z",
    fill: "#FDC860"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9809 62.8181H65.1211V78.7386H75.9809V62.8181Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5862 64.5063H66.5166V77.0524H74.5862V64.5063Z",
    fill: "#61A7A9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5879 71.6245V69.9363H66.4995V71.6245H74.5879Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9555 62.8181H4.0957V78.7386H14.9555V62.8181Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5603 64.5063H5.49072V77.0524H13.5603V64.5063Z",
    fill: "#61A7A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 71.6245V69.9363H5.4741V71.6245H13.5625Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2119 62.8181H19.3521V78.7386H30.2119V62.8181Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8186 64.5063H20.749V77.0524H28.8186V64.5063Z",
    fill: "#61A7A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8188 71.6245V69.9363H20.7304V71.6245H28.8188Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4682 62.8181H34.6084V78.7386H45.4682V62.8181Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.073 64.5063H36.0034V77.0524H44.073V64.5063Z",
    fill: "#61A7A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0752 71.6245V69.9363H35.9868V71.6245H44.0752Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.007 62.8203H126.147V78.7408H137.007V62.8203Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M135.612 64.5063H127.542V77.0524H135.612V64.5063Z",
    fill: "#61A7A9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.614 71.6245V69.9363H127.526V71.6245H135.614Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7246 62.8181H49.8647V78.7386H60.7246V62.8181Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3293 64.5063H51.2598V77.0524H59.3293V64.5063Z",
    fill: "#61A7A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7479 110.941H0.263672V114H49.7479V110.941Z",
    fill: "#98724B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3315 71.6245V69.9363H51.2431V71.6245H59.3315Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9809 43.4648H65.1211V59.3854H75.9809V43.4648Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5862 45.1509H66.5166V57.697H74.5862V45.1509Z",
    fill: "#61A7A9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5879 52.2713V50.583H66.4995V52.2713H74.5879Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7246 43.4648H49.8647V59.3854H60.7246V43.4648Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3293 45.1509H51.2598V57.697H59.3293V45.1509Z",
    fill: "#61A7A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3315 52.2713V50.583H51.2431V52.2713H59.3315Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2378 43.4648H80.3779V59.3854H91.2378V43.4648Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8425 45.1509H81.7729V57.697H89.8425V45.1509Z",
    fill: "#61A7A9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8447 52.2713V50.583H81.7563V52.2713H89.8447Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2524 94.1375V113.873H78.4934V96.1429H70.8944V113.873H69.9615V96.1429H62.3605V113.873H60.6035V94.1375H80.2524Z",
    fill: "#6B5035"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M54.1463 92.7517H50.603V113.873H54.1463V92.7517Z",
    fill: "#704E27"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M90.3318 92.7517H86.7886V113.873H90.3318V92.7517Z",
    fill: "#704E27"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2908 92.7517H49.7476V113.873H53.2908V92.7517Z",
    fill: "#FFF1D7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6894 92.7517H87.5562V113.873H90.6894V92.7517Z",
    fill: "#FFF1D7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.667 114L140.753 110.899H90.6895V114H140.667Z",
    fill: "#98724B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9593 96.1428H62.3604V113.873H69.9593V96.1428Z",
    fill: "#A6733A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4935 96.1428H70.8945V113.873H78.4935V96.1428Z",
    fill: "#A6733A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6785 105.809C71.4902 105.809 71.3354 105.657 71.3354 105.467V103.411C71.3354 103.224 71.4881 103.069 71.6785 103.069C71.8667 103.069 72.0215 103.221 72.0215 103.411V105.467C72.0215 105.655 71.8688 105.809 71.6785 105.809Z",
    fill: "#6B5035"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M69.177 105.809C68.9888 105.809 68.834 105.657 68.834 105.467V103.411C68.834 103.224 68.9867 103.069 69.177 103.069C69.3653 103.069 69.52 103.221 69.52 103.411V105.467C69.52 105.655 69.3674 105.809 69.177 105.809Z",
    fill: "#6B5035"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3653 88.7452C58.1708 88.814 57.7901 88.9288 57.3383 88.9288C56.8322 88.9288 56.4138 88.7994 56.0875 88.4885C55.7989 88.2109 55.6211 87.7644 55.6211 87.2447C55.6253 86.2493 56.3113 85.521 57.4345 85.521C57.8215 85.521 58.1248 85.6045 58.2691 85.6754L58.1645 86.0281C57.9867 85.9488 57.7629 85.8841 57.4241 85.8841C56.6104 85.8841 56.0792 86.3891 56.0792 87.2259C56.0792 88.0628 56.5916 88.574 57.3697 88.574C57.6521 88.574 57.8466 88.5344 57.9449 88.4843V87.4889H57.2651V87.1425H58.3674V88.7473L58.3653 88.7452Z",
    fill: "#A6733A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8856 87.1905C61.8856 88.3403 61.1849 88.9497 60.3315 88.9497C59.4781 88.9497 58.8276 88.2652 58.8276 87.2551C58.8276 86.195 59.4885 85.5022 60.3817 85.5022C61.2748 85.5022 61.8856 86.2013 61.8856 87.1925V87.1905ZM59.2877 87.2447C59.2877 87.9584 59.6747 88.597 60.3545 88.597C61.0343 88.597 61.4275 87.9668 61.4275 87.2092C61.4275 86.5456 61.0803 85.8507 60.3607 85.8507C59.6412 85.8507 59.2877 86.5101 59.2877 87.2426V87.2447Z",
    fill: "#A6733A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1824 88.8933L62.0906 85.5543H62.557L63.0778 87.1988C63.2222 87.6495 63.3456 88.0565 63.4355 88.4467H63.446C63.5401 88.0606 63.6802 87.6391 63.8287 87.2029L64.3956 85.5522H64.8578L63.6614 88.8912H63.1845L63.1824 88.8933Z",
    fill: "#A6733A"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9516 87.3283H65.6506V88.5324H67.1001V88.8934H65.2176V85.5544H67.0248V85.9155H65.6485V86.9714H66.9495V87.3283H66.9516Z",
    fill: "#A6733A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6606 85.6004C67.8802 85.5565 68.1919 85.5315 68.4889 85.5315C68.9511 85.5315 69.2482 85.615 69.4573 85.8049C69.6267 85.953 69.7209 86.1805 69.7209 86.4393C69.7209 86.8796 69.4427 87.1718 69.0913 87.2907V87.3053C69.3486 87.395 69.5033 87.6329 69.5828 87.9794C69.6916 88.4447 69.7711 88.7682 69.8401 88.8955H69.3925C69.3381 88.8016 69.2628 88.5136 69.1687 88.0983C69.0704 87.6371 68.8905 87.4639 68.4993 87.4493H68.0915V88.8955H67.6585V85.6004H67.6606ZM68.0936 87.1196H68.5349C68.9972 87.1196 69.29 86.8671 69.29 86.4852C69.29 86.0532 68.9762 85.8654 68.5203 85.8612C68.3111 85.8612 68.1626 85.88 68.0936 85.9009V87.1196Z",
    fill: "#A6733A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3317 88.8934V85.5544H70.8044L71.8774 87.2448C72.1263 87.6371 72.3187 87.9877 72.4777 88.3299L72.4882 88.3258C72.4484 87.8792 72.438 87.4743 72.438 86.9526V85.5544H72.8458V88.8934H72.4087L71.3461 87.1989C71.1119 86.8274 70.8901 86.4455 70.7207 86.0845L70.7061 86.0887C70.7312 86.5102 70.7416 86.9109 70.7416 87.466V88.8934H70.3338H70.3317Z",
    fill: "#A6733A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4204 87.4283C76.3953 86.9629 76.3661 86.4037 76.3702 85.9863H76.3556C76.2406 86.3786 76.1025 86.7939 75.9331 87.2551L75.3412 88.8745H75.0128L74.471 87.2843C74.3121 86.8127 74.1782 86.3828 74.0841 85.9863H74.0736C74.0632 86.4016 74.0381 86.9629 74.0088 87.4638L73.9188 88.8953H73.5068L73.741 85.5564H74.2911L74.8622 87.1716C75.0023 87.5827 75.1153 87.95 75.1989 88.2964H75.2136C75.2972 87.9604 75.4164 87.5932 75.567 87.1716L76.1632 85.5564H76.7154L76.9245 88.8953H76.502L76.4183 87.4283H76.4204Z",
    fill: "#A6733A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3257 87.3283H78.0247V88.5324H79.4742V88.8934H77.5917V85.5544H79.3989V85.9155H78.0226V86.9714H79.3236V87.3283H79.3257Z",
    fill: "#A6733A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0369 88.8934V85.5544H80.5096L81.5826 87.2448C81.8315 87.6371 82.0239 87.9877 82.1829 88.3299L82.1934 88.3258C82.1536 87.8792 82.1432 87.4743 82.1432 86.9526V85.5544H82.551V88.8934H82.1139L81.0513 87.1989C80.8171 86.8274 80.5953 86.4455 80.4259 86.0845L80.4113 86.0887C80.4364 86.5102 80.4468 86.9109 80.4468 87.466V88.8934H80.039H80.0369Z",
    fill: "#A6733A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9399 85.9217H82.9213V85.5544H85.3999V85.9217H84.377V88.8955H83.9399V85.9217Z",
    fill: "#A6733A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0103 37.2627H43.8428V40.0319H97.0103V37.2627Z",
    fill: "#A6733A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9495 58.3418H0V60.6582H44.9495V58.3418Z",
    fill: "#FDC860"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M141 58.3418H95.8979V60.6582H141V58.3418Z",
    fill: "#FDC860"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52562 85.9299C6.5262 85.9299 4.0957 88.3548 4.0957 91.3474V103.155H14.9555V91.3474C14.9555 88.3548 12.525 85.9299 9.52562 85.9299Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9952 91.9149V102.115H5.05762V91.9149C5.05762 89.4545 7.05723 87.4595 9.52328 87.4595C10.0671 87.4595 10.5858 87.5555 11.0669 87.7328C12.05 88.0918 12.872 88.7867 13.3886 89.6778C13.7338 90.2684 13.945 90.9424 13.9848 91.6665C13.9889 91.75 13.9931 91.8314 13.9931 91.9149H13.9952Z",
    fill: "#61A7A9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6584 85.9299C20.659 85.9299 18.2285 88.3548 18.2285 91.3474V103.155H29.0883V91.3474C29.0883 88.3548 26.6579 85.9299 23.6584 85.9299Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1243 91.9149V102.115H19.1909V91.9149C19.1909 89.4545 21.1905 87.4595 23.6566 87.4595C24.3426 87.4595 24.9952 87.616 25.5767 87.8915C26.5138 88.3359 27.2668 89.0935 27.7039 90.0305C27.9758 90.6023 28.1243 91.2429 28.1243 91.917V91.9149Z",
    fill: "#61A7A9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7898 85.9299C40.7871 85.9299 43.2197 88.3569 43.2197 91.3474V103.155H32.3599V91.3474C32.3599 88.3569 34.7924 85.9299 37.7898 85.9299Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2557 91.9149V102.115H33.3223V91.9149C33.3223 89.4545 35.3219 87.4595 37.7879 87.4595C38.635 87.4595 39.4278 87.6953 40.1034 88.1043C40.9861 88.6385 41.6679 89.4691 42.0089 90.4583C42.1699 90.9153 42.2557 91.4057 42.2557 91.9149Z",
    fill: "#61A7A9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M103.066 85.9299C100.066 85.9299 97.6357 88.3548 97.6357 91.3474V103.155H108.496V91.3474C108.496 88.3548 106.065 85.9299 103.066 85.9299Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M107.532 91.9149V102.115H98.5981V91.9149C98.5981 89.4545 100.598 87.4595 103.064 87.4595C103.608 87.4595 104.126 87.5555 104.607 87.7328C105.588 88.0939 106.408 88.7867 106.927 89.6778C107.272 90.2684 107.483 90.9424 107.523 91.6665C107.527 91.75 107.532 91.8314 107.532 91.9149Z",
    fill: "#61A7A9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M117.197 85.9299C120.194 85.9299 122.627 88.3569 122.627 91.3474V103.155H111.767V91.3474C111.767 88.3569 114.2 85.9299 117.197 85.9299Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M121.665 91.9149V102.115H112.731V91.9149C112.731 89.4545 114.729 87.4595 117.197 87.4595C117.741 87.4595 118.26 87.5555 118.739 87.7328C119.72 88.0939 120.54 88.7867 121.058 89.6778C121.403 90.2684 121.615 90.9424 121.654 91.6665C121.659 91.75 121.663 91.8314 121.663 91.9149H121.665Z",
    fill: "#61A7A9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M131.328 85.9299C134.326 85.9299 136.758 88.3569 136.758 91.3474V103.155H125.898V91.3474C125.898 88.3569 128.331 85.9299 131.328 85.9299Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M135.796 91.9149V102.115H126.862V91.9149C126.862 89.4545 128.86 87.4595 131.328 87.4595C131.776 87.4595 132.209 87.5242 132.616 87.6473C133.631 87.952 134.493 88.6072 135.062 89.4733C135.43 90.0284 135.672 90.6711 135.758 91.3619C135.781 91.5434 135.794 91.7291 135.794 91.917L135.796 91.9149Z",
    fill: "#61A7A9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M140.753 81.6206H0.263672V83.8014H140.753V81.6206Z",
    fill: "#FDC860"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3293 45.1509V45.3366L51.2598 53.3146V49.0741L55.2255 45.1509H59.3293Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3293 47.9138V52.1543L53.7237 57.6969H51.2598V55.8897L59.3293 47.9138Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5862 45.1509V45.5307L66.5166 53.5087V49.2661L70.679 45.1509H74.5862Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5862 48.1101V52.3464L69.1772 57.6971H66.5166V56.086L74.5862 48.1101Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8446 45.1509V46.1067L81.7729 54.0826V49.8442L86.5189 45.1509H89.8446Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8446 48.6819V52.9244L85.015 57.697H81.7729V56.6599L89.8446 48.6819Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3869 64.5063L5.49072 71.322V67.0857L8.09901 64.5063H12.3869Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5624 65.9211V70.1658L6.5972 77.0524H5.49072V73.9012L13.5624 65.9211Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6431 64.5063L20.749 71.322V67.0815L23.3552 64.5063H27.6431Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8186 65.9211V70.1637L21.8513 77.0524H20.749V73.9012L28.8186 65.9211Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8996 64.5063L36.0034 71.3262V67.0857L38.6117 64.5063H42.8996Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.073 65.9255V70.166L37.1078 77.0526H36.0034V73.9035L44.073 65.9255Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.158 64.5063L51.2598 71.3262V67.0857L53.866 64.5063H58.158Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3293 65.9255V70.166L52.3642 77.0526H51.2598V73.9014L59.3293 65.9255Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4148 64.5063L66.5166 71.322V67.0857L69.1249 64.5063H73.4148Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5862 65.9211V70.1658L67.621 77.0524H66.5166V73.9012L74.5862 65.9211Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9257 62.8181H81.0659V78.7386H91.9257V62.8181Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5305 64.5063H82.4609V77.0524H90.5305V64.5063Z",
    fill: "#61A7A9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5327 71.6226V69.9343H82.4443V71.6226H90.5327Z",
    fill: "white"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.3592 64.5063L82.4609 71.322V67.0857L85.0692 64.5063H89.3592Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5326 65.9211V70.1658L83.5674 77.0524H82.4609V73.9012L90.5326 65.9211Z",
    fill: "white"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.182 62.8181H96.3223V78.7386H107.182V62.8181Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105.787 64.5063H97.7178V77.0524H105.787V64.5063Z",
    fill: "#61A7A9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M105.789 71.6226V69.9343H97.7007V71.6226H105.789Z",
    fill: "white"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.616 64.5063L97.7178 71.322V67.0857L100.326 64.5063H104.616Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.789 65.9211V70.1658L98.8243 77.0524H97.7178V73.9012L105.789 65.9211Z",
    fill: "white"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M122.326 62.8181H111.466V78.7386H122.326V62.8181Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M120.931 64.5063H112.861V77.0524H120.931V64.5063Z",
    fill: "#61A7A9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M120.931 71.6226V69.9343H112.842V71.6226H120.931Z",
    fill: "white"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.757 64.5063L112.861 71.322V67.0857L115.468 64.5063H119.757Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.931 65.9211V70.1658L113.966 77.0524H112.861V73.9012L120.931 65.9211Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.441 64.5063L127.542 71.322V67.0857L130.149 64.5063H134.441Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.612 65.9255V70.166L128.647 77.0526H127.542V73.9014L135.612 65.9255Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 89.6777L5.05957 97.9145V93.674L11.0689 87.7307C12.0519 88.0896 12.874 88.7846 13.3906 89.6757V89.6777Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9951 91.9148V95.8986L7.70759 102.115H5.05957V100.492L13.9888 91.6665C13.993 91.75 13.9972 91.8314 13.9972 91.9148H13.9951Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7039 90.0284L19.1909 98.4467V94.2042L25.5767 87.8894C26.5138 88.3339 27.2668 89.0914 27.7039 90.0284Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1243 92.1904V96.4309L22.3765 102.115H19.1909V101.024L28.1243 92.1904Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0089 90.4584L33.3223 99.0479V94.8074L40.1034 88.1045C40.9861 88.6387 41.6679 89.4693 42.0089 90.4584Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2557 92.7935V97.0339L37.1144 102.115H33.3223V101.623L42.2557 92.7935Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.927 89.6778L98.5981 97.9146V93.6721L104.607 87.7329C105.588 88.0939 106.408 88.7868 106.927 89.6778Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.532 91.9148V95.8986L101.246 102.115H98.5981V100.492L107.523 91.6665C107.527 91.75 107.532 91.8314 107.532 91.9148Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.06 89.6778L112.731 97.9146V93.6721L118.741 87.7329C119.722 88.0939 120.542 88.7868 121.06 89.6778Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.665 91.915V95.8988L115.379 102.115H112.731V100.488L121.656 91.6646C121.661 91.748 121.665 91.8294 121.665 91.9129V91.915Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.064 89.4714L126.862 97.5787V93.3383L132.616 87.6475C133.631 87.9521 134.493 88.6074 135.062 89.4734L135.064 89.4714Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.796 91.915V95.5648L129.169 102.115H126.862V100.154L135.76 91.3599C135.783 91.5414 135.796 91.7271 135.796 91.915Z",
    fill: "white"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M44.9496 45.6538H42.0088V60.6561H44.9496V45.6538Z",
    fill: "#704E27"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M98.8388 45.6538H95.8979V60.6561H98.8388V45.6538Z",
    fill: "#704E27"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M95.8976 40.032H44.9492V41.4406H95.8976V40.032Z",
    fill: "#704E27"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1.67334 60.6582H44.9495L1.67334 62.2484V60.6582Z",
    fill: "#704E27"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M1.67334 83.8035H45.8824V84.8657L1.67334 85.5543V83.8035Z",
    fill: "#704E27"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M95.8979 60.6582H139.18V62.8202L95.8979 60.6582Z",
    fill: "#704E27"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M94.9731 83.8035H139.18V85.93L94.9731 84.8657V83.8035Z",
    fill: "#704E27"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M93.666 90.571C93.666 90.9675 93.5593 91.3411 93.3711 91.6604H47.4824C47.2942 91.3411 47.1875 90.9675 47.1875 90.571H93.666Z",
    fill: "#704E27"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M77.2341 27.7675C77.3052 25.4407 76.3556 23.1577 74.9123 21.3338C73.8351 19.9711 72.4986 18.8442 71.0491 17.8738C76.3117 17.9969 81.3337 19.6914 85.6383 22.6318C90.1144 25.689 93.8167 30.0901 96.2179 35.4784L97.0106 37.2605H70.9717C72.0719 36.4863 73.1135 35.6412 74.0359 34.6687C75.8222 32.7864 77.1546 30.3552 77.2341 27.7675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDf5);
export default __webpack_public_path__ + "static/media/df-5.11ec0ca4c9502df716d990d4913505bb.svg";
export { ForwardRef as ReactComponent };